import { dec } from '@app/shared';
import type { DocumentDto } from '@/entities/document';

export type CashOrderType = 'CASH_IN' | 'CASH_OUT';

/** ПКО — деньги в кассу (получили), РКО — деньги из кассы (отдали). Направление жёстко задано
 * типом окна — в отличие от `PaymentWindow`, здесь нет Segmented-переключателя. */
export function directionOf(type: CashOrderType): 'IN' | 'OUT' {
  return type === 'CASH_IN' ? 'IN' : 'OUT';
}

export function prefixOf(type: CashOrderType): string {
  return type === 'CASH_IN' ? 'ПКО' : 'РКО';
}

export interface CashOrderHeader {
  docDate: string;
  counterpartyId?: string;
  amount: string | null;
  method: 'CASH' | 'CASHLESS' | 'TRANSFER';
  cashOperationType: 'PAYMENT' | 'REFUND';
  comment: string;
}

/** §7: обязательные поля при проведении — зеркало `assertReadyToPost` на бэкенде. */
export function isCashOrderComplete(header: CashOrderHeader): boolean {
  return !!header.counterpartyId && !!header.docDate && !!header.amount && dec(header.amount).gt(0) && !!header.method && !!header.cashOperationType;
}

const STATUS_SUFFIX: Record<string, string> = { DRAFT: ' (черновик)', CANCELLED: ' (отменён)' };

/** «Новый приходный ордер» / «ПКО-5/2026» / «ПКО-5/2026 (черновик)». */
export function windowTitle(type: CashOrderType, doc: DocumentDto | undefined, isNew: boolean): string {
  if (isNew || !doc) return type === 'CASH_IN' ? 'Новый приходный ордер' : 'Новый расходный ордер';
  const suffix = doc.deletedAt ? ' (удалён)' : (STATUS_SUFFIX[doc.status] ?? '');
  return `${prefixOf(type)}-${doc.number}/${doc.numberYear}${suffix}`;
}
